var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccessibilityAmbulantToilet = function SvgAccessibilityAmbulantToilet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 30 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    vectorEffect: "non-scaling-stroke",
    cx: 8.966,
    cy: 6.959,
    r: 1.388
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m6.476 11.96.11 11.757a.55.55 0 0 0 .55.536h.363a.55.55 0 0 0 .55-.55l.428-5.907h.662l.428 5.908a.55.55 0 0 0 .55.549h.363a.55.55 0 0 0 .55-.536l.068-11.82m3.163 12.356-3.16-12.356"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "m11.102 11.897 1.468 1.851a.8.8 0 0 1 .155.474l.093 1.817c.053.46.355.79.792.79a.79.79 0 0 0 .791-.79l-.09-2.045a1.57 1.57 0 0 0-.305-.93l-2.28-2.957a1.03 1.03 0 0 0-.828-.423H6.731c-.329 0-.638.156-.833.42l-2.28 2.956a1.57 1.57 0 0 0-.305.931l-.095 2.047a.791.791 0 0 0 1.582 0l.093-1.816a.8.8 0 0 1 .156-.474l1.427-1.785-3.026 12.29m-2.793.111h28.686m-8.433-10.62v4.293m1.402-4.293v4.293m2.396-4.291H18.4a.76.76 0 0 1-.755-.68l-.418-3.015a.76.76 0 0 1 .676-.833h7.283a.756.756 0 0 1 .754.854l-.478 3.015a.76.76 0 0 1-.754.659M17.4 10.762h8.368"
  })), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    d: "M22.672 24.338a3.7 3.7 0 0 1 .967-2.46c.32-.343.698-.59.973-.976a2.68 2.68 0 0 0 .49-1.676h-7.036c-.019.613.206 1.19.556 1.675.279.388.652.634.974.976.615.672.96 1.549.967 2.46"
  }), /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    strokeLinejoin: "round",
    d: "M25.109 19.285v-.737c0-.246-.2-.445-.445-.445h-6.159c-.245 0-.444.2-.444.445v.737m6.444-7.066h2.116"
  }))));
};
export default SvgAccessibilityAmbulantToilet;